<template>
  <section class="nonlogin-header-box">
    <section class="left">
      <img class="logo" src="~images/logo.png" />
      <span class="title">用户注册</span>
    </section>
    <section class="right">
      <span>
        <router-link to="/login">
          <img class="avantar" src="~images/user.png" />
          <span class="login">请登录</span>
        </router-link>
      </span>
    </section>
  </section>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.nonlogin-header-box {
  background: #ffffff;
  height: 64px;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333333;
  font-size: 14px;
  .left {
    .logo {
      width: 70px;
    }
    .title {
      display: inline-block;
      margin-left: 49px;
    }
  }
  .right {
    .avantar {
      width: 32px;
    }
    .login {
      display: inline-block;
      margin-left: 8px;
    }
  }
}
.getCodeBtn {
  padding-right: 8px;
}
.register-content-box {
  margin: 0 auto;
  padding: 20px 10px;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
}
</style>

